import React from "react";
import UnderOverMobile from "./Statistic/UnderOverMobile";

const UnderOverTableMobile = (props) => {
    const { t } = props;

    return (
        <div className="rhm-card">
            <div className="rhm-card__title">
                {t("labels:keno.numberUnderOver")}
            </div>

            <div className="rhm-card__body">
                <div className="rhm-table-wrap">
                    <table className="rhm-table">
                        <tbody>
                        <UnderOverMobile {...props} />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UnderOverTableMobile;